import styled from 'styled-components'

export const Container = styled.div`
  padding: var(--space-200) var(--space-400) var(--space-100);
  font-size: var(--font-size-200);
  color: var(--text-secondary);
`
